import { render, staticRenderFns } from "./thread-item.vue?vue&type=template&id=55bda51e&scoped=true"
import script from "./thread-item.vue?vue&type=script&lang=js"
export * from "./thread-item.vue?vue&type=script&lang=js"
import style0 from "./thread-item.vue?vue&type=style&index=0&id=55bda51e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bda51e",
  null
  
)

export default component.exports